const lbaKeyValuePairs = angular.module('app.lbaKeyValuePairs', []);

lbaKeyValuePairs.controller('lbaKeyValuePairsCtrl', require('./lbaKeyValuePairsCtrl'));
lbaKeyValuePairs.directive('lbaKeyValuePairs', require('./lbaKeyValuePairsDir'));

export default lbaKeyValuePairs;



// WEBPACK FOOTER //
// ./src/components/lbaKeyValuePair/index.js